module.exports = __webpack_public_path__ + "static/media/7.61d46bae.svg";